import Button from "@/components/common/Button";
import { useState } from "react";
import { API_BASE_URL } from "@/lib/axios";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000); // 10 seconds timeout

    try {
      const res = await fetch(
        `${API_BASE_URL}/api/v1/authentication/user/get-reset-link`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
          signal: controller.signal,
        }
      );

      clearTimeout(timeout);

      if (!res.ok) {
        const responseBody = await res.json();
        throw new Error(responseBody.message || "Failed to send reset link");
      }

      setSent(true);
    } catch (err: any) {
      if (err.name === "AbortError") {
        setError("Request timed out. Please try again.");
      } else {
        setError(err.message || "Something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900">
      <form
        onSubmit={handleSubmit}
        className="bg-slate-800 p-8 rounded-xl shadow-lg w-full max-w-md"
      >
        <h1 className="text-2xl font-bold text-white mb-4">Forgot Password</h1>
        <p className="mb-6 text-slate-400">
          Enter your email and we'll send you a reset link.
        </p>
        <input
          type="email"
          className="w-full p-3 rounded bg-slate-700 text-white border border-slate-600 mb-4"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={loading}
        />
        {error && <div className="text-red-400 mb-4">{error}</div>}
        {sent && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
            <div className="bg-slate-800/90 border border-slate-700 rounded-2xl p-8 shadow-2xl w-full max-w-md text-center relative">
              <h2 className="text-2xl font-semibold text-white mb-2">
                Check your email
              </h2>
              <p className="text-slate-400 text-sm mb-6">
                If an account exists, a reset link has been sent.
              </p>
              <Button
                onClick={() => {
                  navigate("/");
                }}
                className="w-full h-12 bg-cyan-500 hover:bg-cyan-600 text-white font-medium rounded-lg transition-colors"
              >
                Back to Home
              </Button>
            </div>
          </div>
        )}
        <Button type="submit" className="w-full mt-2" disabled={loading}>
          {loading ? "Sending..." : "Send Reset Link"}
        </Button>
      </form>
    </div>
  );
};

export default ForgotPassword;
